import { GetIssueResponseDtoStatusEnum } from '@issuemanager/api-client';
import {
  ActionStatusChip,
  ContainerPopper,
  FakeDropdownBox,
  GroupedStatus,
  IssueStatusChip,
  StatusMultipleSelector,
  useDataGridContext,
} from '@issuemanager/apps/client/components';

import { ActionStatus } from '@issuemanager/constants';
import { Stack, useEventCallback } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IssueGridFilterModel } from './types';

export function IssueGridStatusFilter(): React.JSX.Element {
  const context = useDataGridContext();
  const { t } = useTranslation();

  const issueStatusLabel = t('statusLabels.issue');
  const actionStatusLabel = t('statusLabels.action');

  const issueStatuses: IssueGridFilterModel['status'] =
    context.filterModel.status;
  const actionStatuses: IssueGridFilterModel['actionStatus'] =
    context.filterModel.actionStatus;

  const value: GroupedStatus[] = (issueStatuses ?? []).concat(
    actionStatuses ?? [],
  );

  const handleChange = useEventCallback((newValue: GroupedStatus[]) => {
    const filteredIssueStatuses = newValue.filter(
      (v) => v.group === issueStatusLabel,
    );
    const filteredActionStatuses = newValue.filter(
      (v) => v.group === actionStatusLabel,
    );
    context.setFilterModel((prevState) => ({
      ...prevState,
      status: filteredIssueStatuses,
      actionStatus: filteredActionStatuses,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length ? (
            <Stack direction='row' spacing={0.5}>
              {value.map((v) =>
                v.group === issueStatusLabel ? (
                  <IssueStatusChip
                    key={v.id}
                    status={v.value as GetIssueResponseDtoStatusEnum}
                  />
                ) : (
                  <ActionStatusChip
                    key={v.id}
                    status={v.value as ActionStatus}
                  />
                ),
              )}
            </Stack>
          ) : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <StatusMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
